import React from "react";

const AmbulanceService = () => {
  return (
    <div className="d-flex flex-column align-items-start my-5 shadow bg-body rounded p-4">
      <h4 className="text-start">Ambulance Service</h4>
      <p className="text-start">
        The Cardiac Ambulance is always accompanied by:
        <br />
        Specialist, Nurse, PCA
        <br />
        The Normal Ambulance is always accompanied by:
        <br />
        Nurse, PCA
        <br />
        For any emergency need, please call: <br />
        <strong>01914001234</strong> or <strong>01914001232</strong>
      </p>
    </div>
  );
};

export default AmbulanceService;



// WEBPACK FOOTER //
// ./src/component/frontend/AmbulanceService.js